import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

type ConvertToCamelCase = ReturnType<typeof snakecaseKeys>;

export function convertObjectKeysToCamelCase(variableToChange: ConvertToCamelCase): ConvertToCamelCase {
  return camelcaseKeys(variableToChange, { deep: true });
}

type ConvertToSnakeCase = Record<string | number, unknown> | Record<string | number, unknown>[];

export function convertObjectKeysToSnakeCase(variableToChange: ConvertToSnakeCase) {
  return snakecaseKeys(variableToChange, {
    deep: true
  });
}
